package com.shmbles.web.components

import androidx.compose.runtime.*
import com.shmbles.web.models.Theme
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.icons.fa.FaArrowUp
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.css.px
import org.w3c.dom.events.EventListener

@Composable
fun BackToTopButton() {
    var isVisible by remember { mutableStateOf(false) }

    LaunchedEffect(Unit) {
        val check = {
            val scrollY = window.scrollY.takeIf { it > 0.0 }
                ?: (document.documentElement?.scrollTop ?: document.body?.scrollTop ?: 0.0)
            isVisible = scrollY > 250.0
        }

        val listener = EventListener { check() }
        window.addEventListener("scroll", listener)
        document.addEventListener("scroll", listener)
        window.addEventListener("touchmove", listener)
    }

    Box(
        modifier = Modifier
            .size(50.px)
            .borderRadius(r = 50.px)
            .backgroundColor(Theme.Primary.rgb)
            .cursor(Cursor.Pointer)
            .styleModifier {
                property("position", "fixed")
                property("bottom", "30px")
                property("right", "30px")
                property("z-index", "99999")
                property("box-shadow", "0px 4px 15px rgba(0, 167, 142, 0.4)")
                property("transition", "opacity 300ms ease, transform 300ms ease, visibility 300ms ease")
                if (isVisible) {
                    property("opacity", "1")
                    property("visibility", "visible")
                    property("transform", "scale(1)")
                    property("pointer-events", "auto")
                } else {
                    property("opacity", "0")
                    property("visibility", "hidden")
                    property("transform", "scale(0.7)")
                    property("pointer-events", "none")
                }
            }
            .onClick {
                window.scrollTo(x = 0.0, y = 0.0)
            },
        contentAlignment = Alignment.Center
    ) {
        FaArrowUp(
            modifier = Modifier.color(Colors.White),
            size = IconSize.SM
        )
    }
}
